import { Link } from "react-router-dom";
import { useSite } from "../../context/SiteContext";
import { imgUrl } from "../../lib/api";

export const Logo = ({ className = "h-12", testId = "site-logo", badge = false }) => {
  const { settings } = useSite();
  const src = imgUrl(settings.logo_url);
  return (
    <Link to="/" data-testid={testId} aria-label="Lunessa Spa Masaj Ana Sayfa" className="inline-flex shrink-0 items-center">
      {src ? (
        <span className={badge ? "inline-flex rounded-3xl bg-cream px-4 py-3 shadow-[0_12px_30px_-12px_rgba(0,0,0,0.5)] ring-1 ring-gold/50" : "inline-flex"}>
          <img src={src} alt="lunessa-spa-masaj-sivas-logo" className={`${className} w-auto object-contain`} width="120" height="120" />
        </span>
      ) : (
        <span className="flex flex-col leading-none">
          <span className="text-2xl font-semibold tracking-[0.18em] text-emerald-900">LUNESSA</span>
          <span className="mt-1 text-[10px] tracking-[0.35em] text-gold-deep">SPA &amp; MASAJ</span>
        </span>
      )}
    </Link>
  );
};
